/* Medley Fashion: homepage + collection cards - video fade-in, "+" size picker, add full look. */
(function(){
  if (window.__mhBound) return; window.__mhBound = true;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function reveal(v){ v.classList.add('is-playing'); }
  function watch(v){
    if (!v.paused && v.readyState >= 3) { reveal(v); return; }
    v.addEventListener('playing', function(){ reveal(v); }, { once: true });
    var p = v.play && v.play();
    if (p && p.catch) p.catch(function(){});
  }
  function initVideos(){ document.querySelectorAll('.mh video').forEach(watch); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initVideos); else initVideos();

  function addItems(items, btn, label){
    var old = btn.innerHTML;
    btn.disabled = true; if (label) btn.textContent = 'Adding…';
    fetch(ROOT + 'cart/add.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({ items: items }) })
      .then(function(r){ if(!r.ok) throw new Error(); return r.json(); })
      .then(function(){
        btn.disabled = false; if (label) btn.textContent = 'Added ✓';
        var card = btn.closest('.mh__card'); if (card) card.classList.remove('is-open');
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        var drawer = document.getElementById('mini-cart');
        if (drawer) { setTimeout(function(){ drawer.setAttribute('open', ''); }, 350); }
        if (label) setTimeout(function(){ btn.textContent = label; }, 2200); else btn.innerHTML = old;
      })
      .catch(function(){ btn.disabled = false; if (label) btn.textContent = 'Try again'; else btn.innerHTML = old; });
  }

  document.addEventListener('click', function(e){
    var t = e.target.closest ? e.target : null; if (!t) return;
    var plus = t.closest('[data-mh-plus]');
    if (plus) {
      var single = plus.getAttribute('data-variant');
      if (single) { addItems([{ id: Number(single), quantity: 1 }], plus); return; }
      document.querySelectorAll('.mh__card.is-open').forEach(function(c){ c.classList.remove('is-open'); });
      plus.closest('.mh__card').classList.add('is-open');
      return;
    }
    var x = t.closest('[data-mh-close]');
    if (x) { x.closest('.mh__card').classList.remove('is-open'); return; }
    var size = t.closest('[data-mh-size]');
    if (size) { addItems([{ id: Number(size.getAttribute('data-mh-size')), quantity: 1 }], size); return; }
    var all = t.closest('[data-mh-look-add]');
    if (all) {
      var items = [];
      document.querySelectorAll('[data-mh-look-item] [data-mh-variant]').forEach(function(el){ if (el.value) items.push({ id: Number(el.value), quantity: 1 }); });
      if (items.length) addItems(items, all, 'Add the full look');
    }
  });
})();